//react...
import React from "react";

import "./Examinations.styles.css";

const MehdiGhaderi = () => {
  return (
    <div className="examination-container">
      <div className="box">
        <div className="name"> Mr. Mehdi ghaderi </div>

        <div className="score"> score: 77 / 100</div>
      </div>
    </div>
  );
};

export default MehdiGhaderi;
